import { Loading } from "element-ui";

let loadingInstance;
let loadingCount = 0;

export const showLoading = () => {
  if (loadingCount === 0) {
    loadingInstance = Loading.service({
      target:document.getElementsByClassName('app-container')[0]
    });
  }
  loadingCount++;
};

export const endLoading = () => {
  loadingCount--;
  if (loadingCount <= 0) {
    loadingInstance.close();
  }
};
